import React, { useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ArrowLeft, CheckCircle2 } from 'lucide-react';
import { getServicesData } from '../data/servicesData';
import './ServiceDetail.css';

const ServiceDetail = () => {
  const { slug } = useParams();
  const { t } = useTranslation();

  const services = getServicesData(t);
  const service = services.find((item) => item.slug === slug);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [slug]);

  if (!service) {
    return (
      <section className="service-detail section-padding">
        <div className="container">
          <div className="service-detail-not-found">
            <h2>{t('service_not_found', 'Service not found')}</h2>
            <Link to="/" className="back-link">
              <ArrowLeft size={18} /> {t('back_to_home', 'Back to Home')}
            </Link>
          </div>
        </div>
      </section>
    );
  }

  const { title, heroImage, description, intro, body, highlights } = service;

  return (
    <article className="service-detail">
      <div className="service-detail-hero" style={{ backgroundImage: `url(${heroImage || service.image})` }}>
        <div className="service-detail-overlay" />
        <div className="container">
          <div className="service-detail-hero-content">
            <span className="service-detail-label">{t('services_section_header_label')}</span>
            <h1>{title}</h1>
            <p>{description}</p>
          </div>
        </div>
      </div>

      <section className="service-detail-body section-padding">
        <div className="container">
          <div className="service-detail-grid">
            <div className="service-detail-main">
              {intro && <p className="service-detail-intro">{intro}</p>}
              <div className="service-detail-content">
                {body?.map((paragraph, index) => (
                  <p key={index}>{paragraph}</p>
                ))}
              </div>
              <Link to="/" className="back-link">
                <ArrowLeft size={18} /> {t('back_to_home', 'Back to Home')}
              </Link>
            </div>
            {highlights?.length > 0 && (
              <aside className="service-detail-highlights">
                <h3>{t('service_highlights_title', 'Impact Highlights')}</h3>
                <ul>
                  {highlights.map((item, index) => (
                    <li key={index}>
                      <CheckCircle2 size={20} />
                      <div>
                        <h4>{item.title}</h4>
                        <p>{item.text}</p>
                      </div>
                    </li>
                  ))}
                </ul>
              </aside>
            )}
          </div>
        </div>
      </section>
    </article>
  );
};

export default ServiceDetail;
